<owl-carousel-o class="banner-carousel" [options]="dataSignal().carouselOptions">
  @for (banner of dataSignal().carouselSlide; track banner) { @if (banner.mobile_image_url) {
  <ng-template carouselSlide>
    @if (banner.link_url) {
    <a [href]="banner.link_url" target="_blank">
      <img
        class="img-pc"
        [src]="replaceBucket.replaceBucket(banner.pc_image_url)"
        [alt]="banner.title"
        [title]="banner.title"
        loading="eager"
      />
      <img
        class="img-mobile"
        [src]="replaceBucket.replaceBucket(banner.mobile_image_url)"
        [alt]="banner.title"
        [title]="banner.title"
        loading="eager"
      />
    </a>
    } @if (!banner.link_url) {
    <img
      class="img-pc"
      [src]="replaceBucket.replaceBucket(banner.pc_image_url)"
      [alt]="banner.title"
      [title]="banner.title"
      loading="eager"
    />
    <img
      class="img-mobile"
      [src]="replaceBucket.replaceBucket(banner.mobile_image_url)"
      [alt]="banner.title"
      [title]="banner.title"
      loading="eager"
    />
    }
  </ng-template>
  } }
</owl-carousel-o>
